import { ItemAttribute } from "@types";

type AttributeCompareFn = (a: ItemAttribute, b: ItemAttribute) => number;

export const compareSortOrderAsc: AttributeCompareFn = (a: ItemAttribute, b: ItemAttribute): number => a.sortOrder - b.sortOrder;
export const compareSortOrderDesc: AttributeCompareFn = (a: ItemAttribute, b: ItemAttribute): number => -compareSortOrderAsc(a,b);

export const compareInStockFirst: AttributeCompareFn = (a: ItemAttribute, b: ItemAttribute): number => {
  if(a.isInStock === b.isInStock) return 0;
  if(a.isInStock) return -1;
  if(b.isInStock) return 1;
}

export const compareInStockLast: AttributeCompareFn = (a: ItemAttribute, b: ItemAttribute): number => -compareInStockFirst(a,b);

export const withComparisons = (...compareFns: AttributeCompareFn[]) => (a: ItemAttribute, b: ItemAttribute): number => {
  for(const compareFn of compareFns) {
    const result = compareFn(a,b)
    if(!!result) return result; // Return the first non-zero (i.e. non-equal) result
  }
  return 0;
}

export const defaultAttributeCompare: AttributeCompareFn = compareSortOrderAsc;
export const colorAttributeCompare: AttributeCompareFn = withComparisons(compareInStockFirst, compareSortOrderAsc)
